import { useCurrentNetwork } from '../../../hooks';
import type { TimetableStoreType } from '../types';
import type { Network } from '../../../types/shared';
import timeTableStore from '../facebook/stores/timeTableStore';
import googleTimetableStore from '../google/stores/googleTimetableStore';

const useTimetableStore = (): TimetableStoreType => {
  const network = useCurrentNetwork();

  const stores: Record<Network, TimetableStoreType> = {
    facebook: timeTableStore,
    google: googleTimetableStore,
  };

  return stores[network];
};

export default useTimetableStore;
